import React from 'react'
import PropTypes from 'prop-types'
import { connect } from "react-redux"
import find from 'lodash/find'

import { saveAddress } from "./addressActionCreators"
import { AddressActionCreatorsShape as AddressActionCreators } from "./propTypes"
import AddressEditor from './AddressEditor'

const mapStateToProps = (state, ownProps) => {
  return {
    countriesStatesMap: state.constants.countriesStatesMap,
    countries: state.constants.countries,
    address: find(state.entities.Addresses,
      address => address.Id === ownProps.addressId),
    fipsEndpoint: state.constants.navigation.fipsEndpoint,
    localizationItems: state.constants.localizationItems,
    ...ownProps
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onEditOk: address => {
      let newId = 0;
      const isExistingAddress = !!(typeof (address.Id) !== 'undefined' && address.Id);

      const updateOrAddAction = isExistingAddress
        ? ownProps.addressActionCreators.update(address.Id, address) 
        : ownProps.addressActionCreators.add(address);
      dispatch(updateOrAddAction);
      
      const saveAction = saveAddress(Object.assign({}, { Id: newId }, address));
      dispatch(saveAction);

      if (isExistingAddress) {
        ownProps.onAddressUpdated();
      } else {
        ownProps.onAddressCreated();
      }

      if (isExistingAddress) {
        const selectAction = ownProps.addressActionCreators.select({ addressId: address.Id });
        dispatch(selectAction);
      }
    },
    onEditCancel: ownProps.onEditCancel
  }
}

const AddressEditorContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(AddressEditor);

AddressEditorContainer.propTypes = {
  addressActionCreators: AddressActionCreators.propTypes.isRequired,
  addressId: PropTypes.string,
  onAddressCreated: PropTypes.func.isRequired,
  onAddressUpdated: PropTypes.func.isRequired
}

export default AddressEditorContainer;


// WEBPACK FOOTER //
// ./src/Components/checkout/Features/Address/AddressEditorContainer.js